import React from "react";

export const loadFromStorage = (key, defaultValue, user = null) => {
  try {
    const storageKeySuffix = user ? `_${user}` : "";
    const fullKey = `${key}${storageKeySuffix}`;
    const item = localStorage.getItem(fullKey);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error loading ${key} from storage:`, error);
    return defaultValue;
  }
};

export const saveToStorage = (key, value, user = null) => {
  try {
    const storageKeySuffix = user ? `_${user}` : "";
    const fullKey = `${key}${storageKeySuffix}`;
    localStorage.setItem(fullKey, JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving ${key} to storage:`, error);
  }
};

/**
 * SessionStorage: para datos que NO deben sincronizarse entre pestañas
 * Cada pestaña tiene su propia sesión independiente
 */
export const loadFromSessionStorage = (key, defaultValue, user = null) => {
  try {
    const storageKeySuffix = user ? `_${user}` : "";
    const fullKey = `${key}${storageKeySuffix}`;
    const item = sessionStorage.getItem(fullKey);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error loading ${key} from sessionStorage:`, error);
    return defaultValue;
  }
};

export const saveToSessionStorage = (key, value, user = null) => {
  try {
    const storageKeySuffix = user ? `_${user}` : "";
    const fullKey = `${key}${storageKeySuffix}`;
    sessionStorage.setItem(fullKey, JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving ${key} to sessionStorage:`, error);
  }
};
